import React, { useState, useEffect } from 'react';
import EfIcon from '@elem/ui/ef-icon';
import styles from './index.module.scss';

interface ModalWrapIProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    title?: string;
    children?: React.ReactNode;
    width?: number;
}
const ModalWrap: React.FC<ModalWrapIProps> = ({ open, setOpen, title, children, width }) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleClose = () => {
        setIsVisible(false);
        // document.body.style.overflow = '';
        setTimeout(() => {
            setOpen(false);
        }, 300);
    };

    const handleOpen = () => {
        setIsVisible(true);
        // document.body.style.overflow = 'hidden';
    };

    const handlePrevent = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    useEffect(() => {
        if (open) {
            handleOpen();
            if (typeof window !== 'undefined') {
                const winH = window.innerHeight;
                const calH = winH - 580 - 64;
                const elem = window.document.querySelector('.store-modal-root .store-modal-wrap .modal-content') as HTMLElement;

                if (elem) {
                    if (calH < 10) {
                        elem.style.height = `${winH - 64 - 10}px`;
                    } else {
                        elem.style.height = `${580}px`;
                    }
                }
            }
        }
    }, [open]);

    if (open) {
        return (
            <div className={`${styles['store-ModalWrap-root']} store-modal-root ${isVisible ? 'fade-in' : 'fade-out'}`} onClick={handleClose}>
                <div className={`store-modal-wrap ${isVisible ? 'popup' : 'popout'}`} onClick={handlePrevent}>
                    <div className="modal-title">
                        <span className="title-text">{title}</span>
                        <span className="title-text-icon" onClick={handleClose}>
                            <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1744533108904/cancel.png"></EfIcon>
                        </span>
                    </div>

                    <div className="modal-body">
                        <div className="modal-content">{children}</div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default ModalWrap;
